import config from "@/config";
import http from "@/utils/request";

const api = (url, method = "get") => ({
	url: `${config.API_URL}/admin/version/${url}`,
	[method]: async function (data = {}, requestConfig = {}) {
		return await http[method](this.url, data, requestConfig);
	},
});

export default {
	list: api("getList"),
	detail: api("getDetail"),
	save: api("save", "post"),
	delete: api("delete", "post"),
};
